var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17348",
    d: "M31.561 29.44L21.076 18.958a11.813 11.813 0 10-2.121 2.121l10.484 10.479a1.5 1.5 0 002.122-2.121M3 11.771a8.771 8.771 0 118.771 8.771A8.781 8.781 0 013 11.771",
    fill: "currentColor"
  })));
}
export default SvgSearch;